import { makeObservable, observable, flow, action } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import SubscriberActivitiesSchema from "@/areas/activities/schemas/SubscriberActivitiesSchema";
import { shouldRetryForNode404 } from "@/areas/activities/stores/StoreUtilities";

export default class SubscriberActivitiesStore {
  loading = true;
  continuationToken = null;
  notifications = [];
  lastRead = null;

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      continuationToken: observable,
      notifications: observable,
      lastRead: observable,
      load: flow,
      consume: action,
    });

    this.parentStore = parentStore;
  }

  consume(notification) {
    const index = this.notifications.findIndex((t) => t.id === notification.id);
    if (index !== -1) {
      this.notifications.splice(index, 1, notification);
      this.notifications = [...this.notifications];
    }
  }

  *load(query, options) {
    const parseResult = SubscriberActivitiesSchema.safeParse(query);
    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }

    try {
      this.loading = true;

      if (options?.readReceipt) {
        const result = yield api.get(ApiRoutes.forNodeReadReceipt(query.userId), {
          "axios-retry": { retries: 3, retryCondition: shouldRetryForNode404 },
        });
        this.lastRead = result.data.readAt;
      }

      if (options && options.initial) {
        this.notifications = [];
      }

      const response = yield api.post(ApiRoutes.forSubscriberActivitiesSearch(query.userId), query, {
        "axios-retry": { retries: 3, retryCondition: shouldRetryForNode404 },
      });

      if (options && options.initial) {
        this.notifications = response.data.items;
      } else {
        this.notifications = [...this.notifications, ...response.data.items];
      }

      this.continuationToken = response.data.continuationToken;

      if (options?.readReceipt) {
        setTimeout(() => {
          api.post(ApiRoutes.forNodeReadReceipt(query.userId), {});
        }, 1500);
      }

      return { success: true, data: response.data };
    } catch (e) {
      console.error(e);
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
